export default __webpack_public_path__ + "static/media/linkedin.16e93d2c.svg";